import React from "react";
import { CardFragment } from "../../__generated__/CardFragment";
import {
  getThemeColor,
  getLinkHref,
  getThemeColorButtonVariant
} from "../../utils";
import { formatMultilinesText } from "../../../../helpers/markdown";
import { Box, Typography, Hidden, Button } from "@material-ui/core";
import LocalizedLink from "../../../../components/localized-link";

export default function CardCenteredVariant(props: CardFragment) {
  const ctaLinkHref = getLinkHref(props.ctaLink);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      position="absolute"
      top="50%"
      left="50%"
      style={{ transform: "translate(-50%, -50%)" }}
    >
      {props.title && props.titleNode && (
        <Box marginBottom={{ xs: 2, md: 4 }} textAlign="center">
          <Hidden implementation="css" xsDown>
            <Typography
              variant="h3"
              dangerouslySetInnerHTML={{
                __html: formatMultilinesText(
                  props.titleNode.childMarkdownRemark.html
                )
              }}
              style={{ color: getThemeColor(props.titleTheme, "black") }}
            />
          </Hidden>
          <Hidden implementation="css" smUp>
            <Typography
              variant="h2"
              dangerouslySetInnerHTML={{
                __html: formatMultilinesText(
                  props.titleNode.childMarkdownRemark.html
                )
              }}
              style={{ color: getThemeColor(props.titleTheme, "black") }}
            />
          </Hidden>
        </Box>
      )}
      {props.subtitle && props.subtitleNode && (
        <Box marginBottom={{ xs: 4, md: 8 }}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: formatMultilinesText(
                props.subtitleNode.childMarkdownRemark.html
              )
            }}
            style={{ color: getThemeColor(props.subtitleTheme, "black") }}
          />
        </Box>
      )}
      {props.cta && ctaLinkHref && (
        <Button
          variant="contained"
          component={LocalizedLink}
          to={ctaLinkHref}
          title={props.cta}
          color={getThemeColorButtonVariant(props.ctaTheme, "yellow")}
          style={{ minWidth: "min(100%, 320px)" }}
        >
          {props.cta}
        </Button>
      )}
    </Box>
  );
}
